import React from 'react';
import { Button, Layout, OtherCard, Footer } from 'components';
import { Row, Col } from 'antd';

import './messages.less';
import '../../components/RoutingTabs/routing-tabs.less';
import womenPresenting from 'assests/images/musterilerine-sesini-duyur.png';
import kisiyeOzelMsj from 'assests/images/kisiye-ozel-msj.png';
import mms from 'assests/images/mms.png';
import sms from 'assests/images/sms.png';
import unvanLabel from 'assests/images/unval-label.png';
import timing from 'assests/images/timing.png';
import contactList from 'assests/images/contact-list.png';
import excel from 'assests/images/excel.png';
import { NavLink } from 'react-router-dom';
import IysCard from './partials/iys-card';
import TitleCard from './partials/title-card';



const MessagesPage = () => {
  return (
    <Layout>
      <div className="routing">
        <NavLink to="/Messages" activeClassName="active">
          <span>Mesaj Gönder</span>
        </NavLink>
        <NavLink to="/Guide" activeClassName="active">
          <span>Rehberim</span>
        </NavLink>
        <NavLink to="/BlackList" activeClassName="active">
          <span>Kara Liste</span>
        </NavLink>
      </div>
      <div className="messages-page">
        <section className="section--send-message">
          <div className="container">
            <figure>
              <img src={womenPresenting} alt="Women Presenting Image" />
            </figure>
            <div>
              <h1 className="section__title--big">
                Müşterilerine Sesini Duyur!
              </h1>
              <p className="info-text--big">
              Müşterilerilerinize kampanya ve duyurularınızı iletmek için hızlıca mesaj oluşturabilirsiniz.
              </p>   
              <NavLink to="/NewMessage" >
                <Button type="primary" shape="round">
                  Mesaj Oluştur
                </Button>
              </NavLink>
            </div>
          </div>
        </section>
        <div className="container">
        <TitleCard />
          <IysCard />
          <div className="box">
            <section className="section">
              <div>
                <h2 className="section__title">
                  Şirket Ünvanınızı Kaydedin ve Seçim Yapın
                </h2>
                <Row>
                  <Col span={24}>
                    <div className="solo">
                      <figure>
                        <img src={unvanLabel} alt="Icon Kom" />
                      </figure>
                      <span className="info-text">
                        Zengin İçerikli Mesaj gönderin, mesajlarınız daha çok
                        okunsun! En renkli kampanyayı veya en güzel kutlama
                        mesajını MMS formatında gönderin, görselin gücünü
                        kullanarak fark yaratın.
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </section>
            <section className="section">
              <h2 className="section__title">
                Mesaj Türünü Seçin ve Mesajınızı Oluşturun
              </h2>
              <Row gutter={[0, { xs: 20, sm: 20, md: 20, lg: 0 }]}>
                <Col lg={{ span: 8 }} span={24}>
                  <div>
                    <figure>
                      <img src={sms} alt="Icon Kom" />
                    </figure>
                    <h5 className="section__sub-title">Kısa Mesaj (SMS)</h5>
                    <span className="info-text">
                      Zengin İçerikli Mesaj gönderin, mesajlarınız daha çok
                      okunsun! En renkli kampanyayı veya en güzel kutlama
                      mesajını MMS formatında gönderin, görselin gücünü
                      kullanarak fark yaratın.
                    </span>
                  </div>
                </Col>
                <Col lg={{ span: 8 }} span={24}>
                  <div>
                    <figure>
                      <img src={mms} alt="Icon Kom" />
                    </figure>
                    <h5 className="section__sub-title">
                      Zengin İçerikli Mesaj
                    </h5>
                    <span className="info-text">
                      Zengin İçerikli Mesaj gönderin, mesajlarınız daha çok
                      okunsun! En renkli kampanyayı veya en güzel kutlama
                      mesajını MMS formatında gönderin, görselin gücünü
                      kullanarak fark yaratın.
                    </span>
                  </div>
                </Col>
                <Col lg={{ span: 8 }} span={24}>
                  <div>
                    <figure>
                      <img src={kisiyeOzelMsj} alt="Icon Kom" />
                    </figure>
                    <h5 className="section__sub-title">Kişiye Özel Mesaj </h5>
                    <span className="info-text">
                      Gerekli belgeleri bizimle paylaşarak sahibi veya yetkilisi
                      olduığunuz şirketinizin ünvanını sistemimize kaydedebilir,
                      kayıtlı bulunan ünvanlarınız arasından seçim
                      yapabilirsiniz.
                    </span>
                  </div>
                </Col>
              </Row>
            </section>
            <section className="section">
              <h2 className="section__title">Alıcı Kitlenizi Seçin</h2>
              <Row gutter={[0, { xs: 20, sm: 20, md: 20, lg: 0 }]}>
                <Col lg={{ span: 8, offset: 4 }} span={24}>
                  <div>
                    <figure>
                      <img src={excel} alt="Icon Kom" />
                    </figure>
                    <h5 className="section__sub-title">
                      Excel Dökümanı Ekleyin{' '}
                    </h5>
                    <span className="info-text">
                      Gerekli belgeleri bizimle paylaşarak sahibi veya yetkilisi
                      olduığunuz şirketinizin ünvanını sistemimize kaydedebilir,
                      kayıtlı bulunan ünvanlarınız arasından seçim
                      yapabilirsiniz.
                    </span>
                  </div>
                </Col>
                <Col lg={{ span: 8 }} span={24}>
                  <div>
                    <figure>
                      <img src={contactList} alt="Icon Kom" />
                    </figure>
                    <h5 className="section__sub-title">Rehberinizden Seçin </h5>
                    <span className="info-text">
                      Gerekli belgeleri bizimle paylaşarak sahibi veya yetkilisi
                      olduığunuz şirketinizin ünvanını sistemimize kaydedebilir,
                      kayıtlı bulunan ünvanlarınız arasından seçim
                      yapabilirsiniz.
                    </span>
                  </div>
                </Col>
              </Row>
            </section>
            <section className="section">
              <div>
                <h2 className="section__title">Gönderim Zamanını Planlayın</h2>
                <Row>
                  <Col span={24}>
                    <div className="solo">
                      <figure>
                        <img src={timing} alt="Icon Kom" />
                      </figure>
                      <span className="info-text">
                        Günlük, Haftalık, Aylık planlar oluşturun. Gönderim
                        oluşturma sürecinizi tamamlayın ve hemen
                        müşterilerinizle iletişim kurmaya başlayın.
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </section>
          </div>
          <OtherCard
            content={
              <>
                <span className="other-card__title">
                  Şimdi Mesaj Göndermeye Başla!
                </span>
                <p>
                  Müşteri kitlene kampanya ve duyurularını iletebilmek için
                  hemen mesajını oluşturmaya başla.{' '}
                </p>
              </>
            }
            actions={
              <>  
              <NavLink to="/NewMessage" >
                <Button type="primary" shape="round">
                  Mesaj Oluştur
                </Button></NavLink>
              </>
            }
          />
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default MessagesPage;
